import { render, staticRenderFns } from "./Kayaks.vue?vue&type=template&id=dcc40bfa&"
import script from "./Kayaks.vue?vue&type=script&lang=js&"
export * from "./Kayaks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports